import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';
import { useGetCompanyTheme } from 'ogp/hooks';
import { DetailColumn } from 'redesign';

const useSettingsDetailTheme = (): DetailColumn[] => {
  const { t } = useTranslation('ogp-screen-specific');
  const theme = useTheme();
  const themeQuery = useGetCompanyTheme();

  const colorItems = [
    {
      title: t('settings-theme-primary.title'),
      value: theme.palette.primary.main,
      showColorShowcase: true,
    },
    {
      title: t('settings-theme-secondary.title'),
      value: theme.palette.secondary.main,
      showColorShowcase: true,
    },
    {
      title: t('settings-theme-primary_accent.title'),
      value: theme.palette.lwPrimaryAccentDark[100],
      showColorShowcase: true,
    },
    {
      title: t('settings-theme-secondary_accent.title'),
      value: theme.palette.lwSecondaryAccentDark[100],
      showColorShowcase: true,
    },
  ];

  const logo = themeQuery.data?.logo;
  const logoItems = [
    {
      title: t('settings-theme.portalLogoWide'),
      imageUrl: logo?.portalLogoWideUrl,
      imageSx: { maxWidth: 180, maxHeight: 40 },
      value: logo?.portalLogoWideUrl ? undefined : t('settings-theme.portalLogoWideNotSet'),
    },
    {
      title: t('settings-theme.portalLogoSquare'),
      imageUrl: logo?.portalLogoSquareUrl,
      imageSx: { maxWidth: 80, maxHeight: 80 },
      value: logo?.portalLogoSquareUrl ? undefined : t('settings-theme.portalLogoSquareNotSet'),
    },
  ];

  const columns: DetailColumn[] = [
    { title: t('settings-theme.colors.title'), items: colorItems },
    { title: t('settings-theme.logos.title'), items: logoItems },
  ];

  return columns;
};

export { useSettingsDetailTheme };
